import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

// Context.
import { RouterContext, Paths } from './context/RouterContext'
import { NotificationsContext } from './context/NotificationsContext'
import { PinMenuContext } from './context/PinMenuContext'
import { EditPinContext } from './context/EditPinContext'
import { AuthContext } from './context/AuthContext'
import { EventsContext } from './context/EventsContext'
import { ViewportContext } from './context/ViewportContext'
import { PopupContext } from './context/PopupContext'
import { PolygonsContext } from './context/PolygonsContext'
import { StoreContext } from './store'

// Pages.
import Home from './pages/Home'
import Settings from './pages/Settings'
import Users from './pages/Users'
import Login from './pages/Login'
import UIPlayground from './utility/UIPlayground'

// Overlays.
import Notifications from './components/Notifications'
import Popup from './components/Popup'
import Viewport from './components/Viewport'

function App() {
    return (
        <Context>
            <Switch>
                <Route path={Paths.home} exact><Home /></Route>
                <Route path={Paths.settings}><Settings /></Route>
                <Route path={Paths.users}><Users /></Route>
                <Route path={Paths.login}><Login /></Route>

                <Route path={'/playground'}><UIPlayground /></Route>
            </Switch>

            <Viewport />
            <Notifications />
            <Popup />

        </Context>
    )
}

function Context({ children }) {
    return (
        <Router>
        <EventsContext>
        <RouterContext>
        <PolygonsContext>
        <NotificationsContext>
        <ViewportContext>
        <PopupContext>
        <StoreContext>
        <AuthContext>
        <PinMenuContext>
        <EditPinContext>
        { children }
        </EditPinContext>
        </PinMenuContext>
        </AuthContext>
        </StoreContext>
        </PopupContext>
        </ViewportContext>
        </NotificationsContext>
        </PolygonsContext>
        </RouterContext>
        </EventsContext>
        </Router>
    )
}

export default App